import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "setup-domain-with-digitalocean-dns"
    }}>{`Setup domain with DigitalOcean DNS`}</h2>
    <p><a parentName="p" {...{
        "href": "https://m.do.co/c/a1d5495e08b2"
      }}>{`DigitalOcean`}</a></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Get droplet IP on DigitalOcean`}</p>
        <p parentName="li"><img alt="DigitalOcean IP Address" src="https://github.com/cezerin2/cezerin2/raw/master/docs/images/cezerin-digitalocean.png" /></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Change DNS of your domain name to:`}</p>
      </li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`ns1.digitalocean.com
ns2.digitalocean.com
`}</code></pre>
    <p>{`P.S. You can change DNS at your domain name control panel.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Check WHOIS of your domain name, ensure that DNS successfully changed.`}</p>
        <p parentName="li"><img alt="Domain WHOIS" src="https://github.com/cezerin2/cezerin2/raw/master/docs/images/cezerin-digitalocean-dns-domain-whois.png" /></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Go to DigitalOcean - Networking - Domains.`}</p>
        <p parentName="li"><img alt="DigitalOcean DNS" src="https://github.com/cezerin2/cezerin2/raw/master/docs/images/cezerin-digitalocean-dns.png" /></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Enter domain name.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Select droplet.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Click `}<em parentName="p">{`Add domain`}</em>{` button.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Add `}<inlineCode parentName="p">{`A`}</inlineCode>{` and `}<inlineCode parentName="p">{`CNAME`}</inlineCode>{` records to DigitalOcean DNS.`}</p>
      </li>
    </ul>
    <p><em parentName="p">{`Hostname`}</em>{` - Must be your domain name. `}<em parentName="p">{`Value`}</em>{` - Must be your droplet ip
adddess.`}</p>
    <p><inlineCode parentName="p">{`A`}</inlineCode>{` dns record points to our droplet IP address.`}</p>
    <p>{`Example for cezerin.net:`}</p>
    <p><img alt="DigitalOcean DNS Records" src="https://github.com/cezerin2/cezerin2/raw/master/docs/images/cezerin-digitalocean-dns-domain.png" /></p>
    <p>{`That's all.`}</p>
    <p>{`We have domain name points to our digitalocean droplet.`}</p>
    <p><img alt="DigitalOcean DNS Records" src="https://github.com/cezerin2/cezerin2/raw/master/docs/images/cezerin-digitalocean-dns-domain-added.png" /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      